import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeFileNameCommand extends BaseCommand {
  CommandName = "ChangeFileName";
  Command: {
    Name: string;
    FileTmpId: number;
  };
  constructor(sessionId: string, operationId: string, filetTmpId: number, fileName: string) {
    super(sessionId, operationId);
    this.Command = { Name: fileName, FileTmpId: filetTmpId };
  }
}
